import { createAction } from '@reduxjs/toolkit';

import type { CreateKeyphraseBoostingPayload } from '@polyai/stream/commands/handlers/keyphrase-boosting/create/schema';
import type { DeleteKeyphraseBoostingPayload } from '@polyai/stream/commands/handlers/keyphrase-boosting/delete/schema';
import type { UpdateKeyphraseBoostingPayload } from '@polyai/stream/commands/handlers/keyphrase-boosting/update/schema';

export const PREFIX = 'keyphraseBoosting';

export const createKeyphraseBoosting =
  createAction<CreateKeyphraseBoostingPayload>(`${PREFIX}/create`);

export const deleteKeyphraseBoosting =
  createAction<DeleteKeyphraseBoostingPayload>(`${PREFIX}/delete`);

export const updateKeyphraseBoosting =
  createAction<UpdateKeyphraseBoostingPayload>(`${PREFIX}/update`);
